var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasySetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 98.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.15 21.74l-7.56 57.67A2 2 0 0035 81.53l39.88 13.18H75A2 2 0 0076.89 93l10.49-74.59A2 2 0 0086 16.25h-.14L43 20.05a2 2 0 00-1.85 1.69z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-7{fill:#629fe2}.cls-3{fill:#ff4f48}.cls-4{fill:#e53232}.cls-5{fill:#023b8e}.cls-6{fill:#0b4aaf}.cls-9{fill:#2a7cdd}.cls-11{fill:#fff}.cls-13{fill:#0d3fd5;opacity:.3}.cls-14{fill:#393b5e;opacity:.36}.cls-17{fill:#345aad}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.6 9.75c40.06 20.49-.88 72.34-41.61 84.31s-66 .17-61.45-45.59 63-59.22 103.06-38.72z",
    opacity: 0.1,
    fill: "#629fe2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.17 66.76l.56.07 1.68.26.41.08h.41c4.18.34 8.36-3.85 9.6-9.82 1.28-6.24-1-12.33-5.4-13.69l-3.28-.76c-6.5-1.5-12.71 3.2-13.59 10.22-.83 6.73 3.58 12.71 9.61 13.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.11 47.88c-.14-1-.09-3-1.67-3.15-1.27-.16-2.58 1.36-3.27 2.1a12.42 12.42 0 00-2.46 3.94 21.85 21.85 0 00-1.17 8.66 1.46 1.46 0 01-.34 1.25 1.62 1.62 0 01-1.76 0 3 3 0 01-1-1 11.45 11.45 0 008.74 7.09l.56.07 1.68.26.41.08h.34a2.6 2.6 0 00.49-.44 3.14 3.14 0 00.55-1.46 30.74 30.74 0 00-.06-8.18c-.29-2.97-.58-6.1-1.04-9.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.14 21.47C39.46 7.24 51.71-.15 67.46.08h.93l-4 1.51a4.27 4.27 0 00-.53.24C35 2.49 33.36 41.76 33.26 43.2l-7.52 2.91.26-1.39c0-.44.78-12.84 6.14-23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M32.68 21.47C40 7.24 52.08-.91 68 .08h.93l-4 1.51c-.19.07-.13.25-.3.34-28.85.66-30.73 39.83-30.84 41.27l-7.37 2.6.08-1.08c.03-.44.82-12.84 6.18-23.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M21.93 54.18C23 46.93 28.28 41.8 33.55 43c5.11 1.18 7.92 7.84 6.49 14.6-1.36 6.45-6.16 10.89-10.91 10.16s-8.19-6.68-7.2-13.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.43 54.66C25.5 47.71 30.6 42.79 35.63 44c4.88 1.13 7.52 7.51 6.11 14-1.35 6.2-6 10.48-10.54 9.78s-7.78-6.5-6.77-13.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 55.71c.64-3.66 3.35-6.23 6-5.67s4 3.96 3.3 7.45-3.3 5.83-5.8 5.41-4.15-3.62-3.5-7.19z",
    fill: "#1559d7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36 50a3.46 3.46 0 00-1.36 0c1.83 1.22 2.77 4 2.18 7s-2.44 5-4.5 5.43a3.75 3.75 0 001.22.46c2.51.42 5.08-2 5.8-5.41S38.57 50.59 36 50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.47 16.34s-.18-3.28-4.2-3.05L74 97.52s4.28 1.75 5.91-1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47 16.34s-.18-3.28-4.2-3.05L74 97.52s4.28 1.75 5.91-1.76z",
    opacity: 0.79,
    fill: "#0b4aaf"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M86.38 13.28L42 17.59a2.12 2.12 0 00-1.89 1.83L32 81.5a2.12 2.12 0 001.42 2.28l41.27 14A2.11 2.11 0 0077.4 96l11.28-80.33a2.11 2.11 0 00-2.3-2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.5 21.65l-7.56 57.67a2 2 0 001.38 2.12l39.91 13.18a2 2 0 00.72.1A2 2 0 0076.89 93l10.49-74.59A2 2 0 0086 16.25a2.29 2.29 0 00-.79-.08L42.32 20a2 2 0 00-1.82 1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M41.15 21.74l-7.56 57.67A2 2 0 0035 81.53l39.88 13.18H75A2 2 0 0076.89 93l10.49-74.59A2 2 0 0086 16.25h-.14L43 20.05a2 2 0 00-1.85 1.69z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M46.85 28.28a9 9 0 004.72 4.84 4.56 4.56 0 013.19 4.33L39 37.17 40.22 28zM54.77 38.56l-15.89-.31-1 7.57 13.91.57a16.66 16.66 0 002.98-7.83zM51.57 47.25a10.6 10.6 0 00.2 7.46l-14.71-2.58.71-5.4zM36.88 53.5l13.69 2.11-4.77 3.18a3.38 3.38 0 00-5.08 1L36.16 59zM40.62 60.58s1.19 3.77 5 2.39l1.85 5.83-12.1-3.59.75-5.75zM46.37 62.49s1-2 0-3l5.2-3.12-2.88 11.19zM46.7 70.34l-8.41-2.42-1.24 6.83-2.87-.66-.97 6.98 5.33 1.67 1.29-5.25 4.97 1.4 1.9-8.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M48.78 71.13l8.36 2.19-3.68 14.35-12.82-4.23.58-3.16 4.95 1.44 2.61-10.59zM59.13 66l-1.6 5.37-8.19-2.16 3-13.36s1.87 3.83 5.57 5zM61.33 65.4l-1.21-3.62s8 1.84 7.36 5zM60.92 66.75l7 1.45s3.44 2.58.88 10.16L58.64 76zM68.87 80.88l-10.83-2.81-2.52 10.28 11.09 3.66 2.26-11.13zM72.26 75.7L69.61 93l6.81 2.42 2.6-18.27-6.76-1.45zM72.58 74s1.71-7.17-4-11l12.09 2.84-1.43 9.72zM81.12 62.18l-13.44-3.39-.4 3.19-6.16-2.39 2.18-13.33 8.16 2.19-.6 3.58 11.38 2.19-1.12 7.96zM60.72 52.63L54 50.84a7.89 7.89 0 005.37 7.56zM62.53 45.66l-1.41 6.17-6.97-1.99 2.07-6.17 6.31 1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M57.34 36.31a12.19 12.19 0 01-1 6.1l17.86 4.05-.9 3.78 9.17 2 2-14.4zM56.94 35.32s.56-1.58-3.2-4.12A22.85 22.85 0 0150 28.29l16.47-1.36.42 8.59zM46.49 27.46s-1.54-1.23-.16-3.85H40.8l-.42 3.59zM40.94 22.76h6s2.78-1.24 4 1.38l9.13-5.68-18.87 1.72zM50.93 24.92a2.54 2.54 0 01-1.53 2.7l17-1.54L66 18l-3.89.35zM67.42 17.83l.26 12.73 6.95-.22-.49-13.07-6.72.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M67.83 31.42l8.48-.49-.38-6.39 10.61-.93-1.77 12.64-16.79-.73-.15-4.1zM75.89 23.61l-.52-6.45 12.4-1.2-1.08 6.98-10.8.67z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 43.72,
    cy: 60.72,
    rx: 1.69,
    ry: 1.27
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M86.84 36.68a.61.61 0 00.7-.54l1.66-12.3a.61.61 0 00-.53-.7.62.62 0 00-.71.53L86.3 36a.64.64 0 00.54.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M87 36.71a.48.48 0 00.54-.42l1.7-12.59a.48.48 0 00-.41-.54.48.48 0 00-.54.42l-1.7 12.58a.49.49 0 00.41.55z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 85.49,
    y: 38.54,
    width: 1.25,
    height: 6.98,
    rx: 0.63,
    transform: "rotate(-172.31 86.12 42.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M85.85 45.52a.49.49 0 00.54-.42l.8-6a.48.48 0 00-.41-.54.48.48 0 00-.54.41l-.81 6a.49.49 0 00.42.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87 36.71a.48.48 0 00.54-.42l1.7-12.59a.48.48 0 00-.41-.54.48.48 0 00-.54.42l-1.7 12.58a.49.49 0 00.41.55zM85.85 45.52a.49.49 0 00.54-.42l.8-6a.48.48 0 00-.41-.54.48.48 0 00-.54.41l-.81 6a.49.49 0 00.42.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.19 21.55l-.77 5.83-.28 2.15-.09.64-.66 5.06-.55 4.17-.18 1.38-1.41 10.75c-.15 1.1-.26 2-.33 2.51l-.09.66 4.82-31.51a2.41 2.41 0 012.19-2l43.56-3a2 2 0 00-2.1-2l-42.43 3.9a2 2 0 00-1.68 1.46z",
    opacity: 0.3,
    fill: "#0b4aaf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.41 85.74l1.24-7.24a32.37 32.37 0 00.65-6.72 10.46 10.46 0 00-2.2-6.26 12.66 12.66 0 00-4.39-3.1 69.15 69.15 0 01-7.46-3.59c-2.33-1.48-4.38-3.7-4.82-6.43-.48-2.95 1-5.82 2.16-8.56s2.17-6 .85-8.63c-1.57-3.14-5.77-4.36-7.15-7.59",
    stroke: "#ff4f48",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 48.29,
    cy: 25.07,
    r: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M99.1 62.19c-.77 7-5.55 12.1-10.53 11.68-4.8-.41-8.39-5.82-8.17-12.42.24-7 4.62-13 10-13 5.54-.06 9.52 6.28 8.7 13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.64.09c11.42.17 17.67 4 23.4 11.28 11.65 14.87 6.32 38.73 6.08 39.73L88 49.46c0-.21 4.82-23.86-3-34.83-4.24-5.37-10.89-11.9-22.44-12.69-.07-.55 2.61-1.85 3.08-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.86.39a27.87 27.87 0 015.07-.28c9.45.93 16.9 4.83 21.93 11.26 11.65 14.87 6.32 38.73 6.08 39.73l-7.12-1.64c.05-.21 3.91-24.57-4-35.54-4-5.52-9.84-11.19-21.39-12a4.12 4.12 0 00-.57-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.78 49.11h-3.46c-4.65.39-8.43 5.92-8.68 12.34-.24 6.11 2.81 11.15 7 11.79l3.12.26c6.18.51 12.11-4.32 13-11.14.95-7.17-4.08-13.3-10.98-13.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.4 61.45c.2-5.85 3.31-11 7.5-12.54-5 .18-9.05 5.86-9.23 12.48-.17 6.28 3.22 11.44 7.73 11.93-3.65-1.56-6.19-6.32-6-11.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.73 73.56a12.11 12.11 0 0011.13-5.88 6.36 6.36 0 00-.57.46A20.08 20.08 0 0198.57 71 8 8 0 0194 72a7.07 7.07 0 01-5-3.17 13.46 13.46 0 00-1.82-2.57 8.11 8.11 0 00-2.73-1.52c-.94-.37-1.82-.8-2.74-1.19.42 5.15 3.23 9.18 6.93 9.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M102.16 62.44a5.38 5.38 0 00-1.55-4.55v-.61l-1.8-.2c-2.2-.26-4.06 1.94-4.1 4.74 0 2.63 1.56 4.72 3.51 4.83l1.62.08v-.49a4.87 4.87 0 002.32-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96.55 62c.1-2.76 2-4.93 4.11-4.69s3.45 2.68 3.13 5.29c-.31 2.46-2 4.26-3.9 4.16s-3.44-2.2-3.34-4.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M100.23 62.15a.9.9 0 00-.66-.23.78.78 0 00-.86.66c0 .06-.28 6-6.63 11S75.18 81.2 61 81.09a.63.63 0 00-.67.57.55.55 0 00.16.38.7.7 0 00.5.2 1.17 1.17 0 01.27.3c.17.23.37.49.67.49 13.2 0 23.94-3 31.05-8.55s7.44-11.71 7.45-11.77a.77.77 0 00-.2-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64.34 81.87c-.1 1.22-1.83 2.13-3.86 2s-3.64-1.13-3.58-2.36 1.8-2.17 3.87-2.09 3.68 1.21 3.57 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64.62 2q-.7 0-1.38.06H63a55.94 55.94 0 00-13.54 1.68A35 35 0 0168 .08h.93l-4 1.51c-.2.1-.14.28-.31.41z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasySetup);
export default __webpack_public_path__ + "static/media/easySetup.4d650c5de7fe6fdcb78f3e548c40658a.svg";
export { ForwardRef as ReactComponent };